export const THEME_COLORS = {
    white: 'white',
    black: 'black',
    gray: 'gray',
    darkGray: 'darkGray',
    red: 'red',
    magenta: 'magenta',
    lightBlue: 'lighBlue',
    blue: 'blue',
    green: 'green',
    darkBlue: 'darkBlue',
    orange: 'orange',
    transparent: 'transparent',
    shadowBlue: 'shadowBlue',
    shadowRed: 'shadowRed',
    whiteHover: 'whiteHover',
    blackPressed: 'blackPressed',
    blueViolet: 'blueViolet',
    greenBlue: 'greenBlue',
    pinkOrange: 'pinkOrange',
    yellowPink: 'yellowPink',
    loginGradient: 'loginGradient',
    greenBlueReversed: 'greenBlueReversed'
}

export const FONTS = {
    bold: 'bold',
    boldItalic: 'boldItalic',
    italic: 'italic',
    light: 'light',
    lightItalic: 'lightItalic',
    medium: 'medium',
    mediumItalic: 'mediumItalic',
    mono: 'mono',
    regular: 'regular',
}

export const GRADIENTS = {
    blueViolet: 'blueViolet',
    greenBlue: 'greenBlue',
    pinkOrange: 'pinkOrange',
    yellowPink: 'yellowPink',
}

export const MEDIA_QUERIES = {
    phone: 'phone',
    tablet: 'tablet',
    ipad: 'ipad',
    desktop: 'desktop',
    small: 'small'
}

export const TRANSITIONS = {
    base: 'base',
}

export const BREAKPOINTS = {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
}

export const theme = {
    assetsUrl: '/public',
    font: {
        [FONTS.bold]: '"ApercuBold", sans-serif',
        [FONTS.boldItalic]: '"ApercuBoldItalic", sans-serif',
        [FONTS.italic]: '"ApercuItalic", sans-serif',
        [FONTS.light]: '"ApercuLight", sans-serif',
        [FONTS.lightItalic]: '"ApercuLightItalic", sans-serif',
        [FONTS.medium]: '"ApercuMedium", sans-serif',
        [FONTS.mediumItalic]: '"ApercuMediumItalic", sans-serif',
        [FONTS.mono]: '"ApercuMono", sans-serif',
        [FONTS.regular]: '"ApercuRegular", sans-serif',
    },
    color: {
        [THEME_COLORS.white]: '#FFF',
        [THEME_COLORS.black]: '#000',
        [THEME_COLORS.gray]: '#CBCBCB',
        [THEME_COLORS.darkGray]: '#818181',
        [THEME_COLORS.red]: '#F00',
        [THEME_COLORS.magenta]: '#e81c69',
        [THEME_COLORS.lightBlue]: '#077BBE',
        [THEME_COLORS.blue]: '#204386',
        [THEME_COLORS.green]: '#6EC18A',
        [THEME_COLORS.darkBlue]: '#3F5063',
        [THEME_COLORS.orange]: '#F09724',
        [THEME_COLORS.transparent]: 'transparent',
        [THEME_COLORS.shadowBlue]: 'rgba(81, 129, 186, .25)',
        [THEME_COLORS.shadowRed]: 'rgba(95, 11, 43, .3)',
        [THEME_COLORS.whiteHover]: 'rgba(255, 255, 255, .1)',
        [THEME_COLORS.blackPressed]: 'rgba(0, 0, 0, .07)',
        [THEME_COLORS.blueViolet]: 'linear-gradient(255deg, #7E2889, #1587C8)',
        [THEME_COLORS.greenBlue]: 'linear-gradient(255deg, #0E89CA, #6EC18A)',
        greenBlueDiagonal: 'linear-gradient(to bottom right, #6EC18A, #0E89CA)',
        [THEME_COLORS.greenBlueReversed]: 'linear-gradient(137deg, #6ec18a, #0e89ca)',
        [THEME_COLORS.pinkOrange]: 'linear-gradient(255deg, #F09724, #E81C69)',
        [THEME_COLORS.yellowPink]: 'linear-gradient(255deg, #F49593, #F7BF28)',
        [THEME_COLORS.loginGradient]: 'linear-gradient(to bottom, #f53ca2, #e81c69)',
    },
    gradients: {
        [GRADIENTS.blueViolet]: ['#7E2889', '#1587C8'],
        [GRADIENTS.greenBlue]: ['#0E89CA', '#6EC18A'],
        [GRADIENTS.pinkOrange]: ['#F09724', '#E81C69'],
        [GRADIENTS.yellowPink]: ['#F49593', '#F7BF28'],
    },
    mediaQueries: {
        [MEDIA_QUERIES.phone]: '@media (max-width: 767px)',
        [MEDIA_QUERIES.tablet]: '@media (min-width: 768px)',
        [MEDIA_QUERIES.ipad]: '@media (min-width: 960px)',
        largeDevices: '@media (min-width: 992px)',
        [MEDIA_QUERIES.desktop]: '@media (min-width: 1200px)',
        [MEDIA_QUERIES.small]: '@media (max-height: 799px) and (min-width: 1280px)',
    },
    transitions: {
        [TRANSITIONS.base]: '.2 ease-in 0s'
    },
}
